import { CompoundComponentProps } from '@/types/common';

import {
  Footer,
  MainHeading,
  SecondaryHeading,
  SlideHeading,
  SlideSectionHeading,
} from './accessoryComponents';
import { PresentationSlide as Slide } from './PresentationSlide';

export const PresentationSlide = {
  Slide,
  MainHeading,
  SecondaryHeading,
  SlideHeading,
  SlideSectionHeading,
  Footer,
};

export type PresentationSlideProps = CompoundComponentProps<
  typeof PresentationSlide
>;
